import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M9.75 11.75H17V18H9.75zM1 11.75h7.25V18H1zM15.482 4a2.494 2.494 0 0 0-.214-3.27 2.499 2.499 0 0 0-3.531.001L8.999 3.469 6.261.73A2.502 2.502 0 0 0 2.73.731 2.493 2.493 0 0 0 2.517 4H1v6.25h7.25V5.2h1.5v5.05H17V4h-1.518zM4.165 4l-.586-.586a1.297 1.297 0 0 1 1.833-1.835L7.833 4H4.165zm10.254-.587L13.832 4h-3.667l2.421-2.42a1.298 1.298 0 0 1 1.833-.001 1.298 1.298 0 0 1 0 1.834z" />
  </svg>
);

export default SvgComponent;
